<div class="modal-header">
  <h4 class="modal-title">
    @if (staff) {
      Editar {{ staff.getFullName }}
    }

    @if (!staff) {
      Nuevo empleado
    }
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body">
  @if (!loading) {

    <!-- Contexto de sucursal -->
    <p class="text-muted small d-flex align-items-center gap-1 mb-3">
      <i class="material-icons" style="font-size: 1rem; line-height: 1;">store</i>
      Sucursal: <strong class="text-body ms-1">{{ branchService.currentBranch?.name }}</strong>
    </p>

    <form
      id="formStaff"
      [formGroup]="formStaff"
      (ngSubmit)="onSubmit()">
      <div class="container-fluid">
        <div class="row">

          @for (key of utilService.objectKeys(dataForm); track key) {

            @if (dataForm[key].type == 'text') {
              <div class="col-12 form-group mb-4">
                <label [htmlFor]="key" class="form-label">
                  {{ dataForm[key].label }}
                </label>
                <input
                  [type]="dataForm[key].type"
                  class="form-control"
                  formControlName="{{ key }}"
                  [placeholder]="dataForm[key].placeholder ?? dataForm[key].label"
                  [ngClass]="{
                    'is-invalid': submitted && f[key].errors
                  }">
                @if (submitted && f[key].errors && dataForm[key].required) {
                  <div class="invalid-feedback">
                    @if (f[key].errors!['required']) {
                      <div>{{ dataForm[key].requiredMessage }}</div>
                    }
                  </div>
                }
              </div>
            }

          }
        </div>
      </div>
    </form>
  }
</div>

<div class="modal-footer">
  <div class="col-12 my-3">
    <button
      (click)="activeModal.close()"
      type="button"
      class="btn btn-outline-danger w-100">
      Cancelar
    </button>
  </div>
  <div class="col-12">
    <button
      type="submit"
      form="formStaff"
      class="btn btn-primary w-100">
      {{ staff ? 'Actualizar' : 'Registrar' }}
    </button>
  </div>
</div>
